import { render, staticRenderFns } from "./StatisticsHeader.vue?vue&type=template&id=0a4ded1f&scoped=true"
import script from "./StatisticsHeader.vue?vue&type=script&lang=js"
export * from "./StatisticsHeader.vue?vue&type=script&lang=js"
import style0 from "./StatisticsHeader.vue?vue&type=style&index=0&id=0a4ded1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4ded1f",
  null
  
)

export default component.exports